import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const LanguagesQuery = gql`
    query {
        languages {
            id
            value
        }
    }
`;

const CreateLanguageMutation = gql`
    mutation($language: LanguageInput!) {
        createLanguage(language: $language) {
            id
        }
    }
`;

const DeleteLanguageMutation = gql`
    mutation($id: String!) {
        deleteLanguage(id: $id) {
            id
        }
    }
`;

interface IInputProps {
    children?: any;
}

interface Response {
    data: any;
}

class GetLanguagesQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const { languages, createLanguage, deleteLanguage }: any = this.props;
        return this.props.children({
            languages,
            createLanguage,
            deleteLanguage
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(LanguagesQuery, {
        name: 'languages'
    }),
    graphql<IInputProps, Response>(CreateLanguageMutation, {
        name: 'createLanguage'
    }),
    graphql<IInputProps, Response>(DeleteLanguageMutation, {
        name: 'deleteLanguage'
    })
)(GetLanguagesQuery);



// WEBPACK FOOTER //
// ./src/components/Query/Languages/Languages.tsx